import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import '../distributionLog/distributionLog.less'
import { requests, getToken, loadZhuKeToken,getLoginShopInfo,systemConfig,getZkShopName,getTaoteShopName,messageShow } from '../../utils/http';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import { huoyuanLink } from '../../utils/index'
import { trim } from 'lodash';
import ShowModal from '../../components/showModal/index.jsx';
import { loadSizeComponentTamplate,saveSizeComponentTamplate,GetListingProductByCateIdRequest } from '../../utils/api';
import ListingProductEdit from '../../components/listingProductEditV2';
import { productExposureReport } from '../../utils/alibabareport.js';

class distributionLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alibabaPageKey:'distribution_log',
      daySelect: [{ value: "7", label: "7天",isSelect:false}, { value: "15", label: "15天",isSelect:false }, { value: "30", label: "30天",isSelect:true }],
      selectDay:"30",
      productTitle:"",//输入框（商品标题）
      
      distributionStatus: [
        { id: 0, value: "distributioning", title: "全部", active: true, num: "" },
        { id: 1, value: "distributionSuccess", title: "铺货中", active: false, num: "" },
        { id: 2, value: "distributionError", title: "铺货成功", active: false, num: "" },
        { id: 3, value: "distributionError", title: "铺货失败", active: false, num: "" }
     ],
      selectShopId: "",//当前登录的店铺id，非阿里的
      selectShopName:'',//列表显示的店铺名称
      selectplatformType: "WxVideo",//当前登录的店铺类型
      indexs:"0",
      logList:[],

      isLoading: false,
      pageSize: 10,
      current: 1,
      total: 0,
      listingProductSubStauts:{
        WaitMaterialAudit:{ text:"等待图片审核..." }
      },

      //================================上传尺码表相关功能====================================
      upSizeTitle: "",//上传尺码标题展示
      upSizeTitleLenght: 0,
      upSizeDesc: "",//上传尺码注释展示
      upSizeDescLength: 0,
      upTemplateSubType:'',
      upSizeSpecOptions: [ //上传尺码 可选择的规格选项
      ],
      upSizeCustomSku: "",//自定义规格名称
      isShowCustomSku: false,//是显自定义规格名称弹窗
      upSizeConfigTable: [//用户填写的值
      ],
      selectedTask:null,
      isShowUpSizeCustomSkuDailog:false,//显示添加尺码的弹窗
      
      isShowListingProductEditDailog: false,
      listingProductEditByProduct: null,//修改的商品id
    };
  }
  componentDidMount() {
    var zhukeToken=getToken();
    var that=this;
    if(zhukeToken !="")
       that.loadData();
    else{

      setTimeout(() => {
        var zhukeTokenTwo=getToken();
        if(zhukeTokenTwo ==""){
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试。
          if(hasZhukeLoginShopTokens !=null && hasZhukeLoginShopTokens !="" && hasZhukeLoginShopTokens !=undefined)
          {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree=getToken();
              if(zhukeTokenThree !="")
                 that.loadData();
              else
                that.setState({isShowWarn: true});
              
            }, 500);
          }else
             that.setState({ isShowWarn: true}); 
        }else
          that.loadData();
      }, 500);
      
    }
  }
  urlLink = (url,state) => {
    const path = { pathname: url, state: { data: state } }
    this.props.history.push(path);
  }
  changeNav = (name) => {
    this.props.history.replace(name)
  }

  loadData=()=>{
    var shopInfo=getLoginShopInfo();
    var that=this;
    this.setState({
      selectShopId:shopInfo.loginShopId,
      selectShopName:shopInfo.loginShopName,
      selectplatformType:shopInfo.loginShopPlatformType,
    },()=>{
      that.queryButton();
    })
   
  }

  changeNav = (name) => {
    this.props.history.replace(name)
  }


  changeSelect = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  onChangeInput = (name, value) => {
    let obj = {};
    obj[name] = value.trim();
    this.setState(obj);
  }

  changeCurrent = (current) => {
    this.setState({
      current,
      checkAll: false
    }, () => {
      this.queryButton();
    })
  }
  changePageSize = (size) => {
    this.setState({
      pageSize: size,
      current: 1,
    }, () => {
      this.queryButton();
    })
  }

  changeTabs = (obj) => {
    let index = obj.props.name;
     
    var distributionStatus =this.state.distributionStatus;

    for (var i = 0; i < distributionStatus.length; i++) {
      if (distributionStatus[i].id == index) 
          distributionStatus[i].active = true;
      else
          distributionStatus[i].active = false;
    }

    this.setState({distributionStatus:distributionStatus,indexs:index},()=>{
       this.queryButton(true);
    })



  }

  showListingProductEditDailog = (item) => {

    var obj = {};
    obj.taskCode = item.ListingTask.ListingTaskCode;
    obj.targetPlatformType = item.ListingTask.TargetPlatformType;
    obj.targetShopId = item.ListingTask.TargetShopId;
    obj.supplierProductId = item.ListingTask.SupplierProductId;
    obj.supplierProductCode = item.ListingTask.SupplierProductCode;
    obj.sourcePlatform = item.ListingTask.SourcePlatform == null ? "" : item.ListingTask.SourcePlatform;
    obj.supplierProductTag = item.ListingTask.SupplierProductTag == null ? "" : item.ListingTask.SupplierProductTag;
    this.setState({
        isShowListingProductEditDailog: true,
        listingProductEditByProduct: obj
    });

 }


  
    cancelModul = (typeName) => {
    this.setState({ [typeName]: false });

    if (typeName != 'isShowListingProductEditDailog')
        this.queryButton(true);
    }
  loadLogList=()=>{

    if(this.state.isShowWarn){
      Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
      return;
    }

    var status = "";
    if (this.state.indexs == 1)
        status = "doing";
    else if (this.state.indexs == 2)
        status = "success";
    else if (this.state.indexs == 3)
        status = "error";

    var data = {
      ShopIdList: [this.state.selectShopId],
      PageIndex: this.state.current,
      PageSize: this.state.pageSize,
      ProductTitle: this.state.productTitle,
      SaleState: status,
      Days: this.state.selectDay,
      SourcePlatform:"all",
    }
    var that=this;
    that.setState({ isLoading: true });
    requests({
      url: "/DistributionLog/List",
      data: data,
      success: (json) => {
        that.setState({ isLoading: false });
        var distributionStatus = that.state.distributionStatus;
        if (json.Success) {
          var distributionLogList = json.Data.DistributionLogList;
          var totalCount = json.Data.TotalCount;

          if (totalCount == 0) {
              that.setState({
                  isNotList: true
              })
          } else {
              that.setState({
                  isNotList: false
              })
          }


          for (var i = 0; i < distributionStatus.length; i++) {
              if (distributionStatus[i].active == true) {
                  distributionStatus[i].num = totalCount;
                  break;
              }
          }
          var reportPids=[]
          distributionLogList.forEach(x => {
                if(reportPids.includes(x.SupplierProduct.ProductId) == false){
                    reportPids.push(x.SupplierProduct.ProductId);
                }
            });

          productExposureReport(reportPids,this.state.alibabaPageKey);

          that.setState({ total: totalCount, logList: distributionLogList, distributionStatus: distributionStatus });
        } else {
          Message({
            showClose: true,
            message: json.Message,
            type: 'error'
          });
        }
      },
      fail: (err) => { }
    })
  

  }


  queryButton = (isQuery) => {
   
    // var shopname = '';
    // var shopList = this.state.shopList;
    // for (var i = 0; i < shopList.length; i++) {
    //     if (shopList[i].Id == shopid) {
    //         shopid = shopList[i].Id;
    //         shopname = shopList[i].ShopName;
    //     }
    // }
    if (isQuery) {  //为true 时为搜索调用  current恢复第1页
        this.setState({ current: 1 }, () => {
            this.loadLogList();
        })
    } else {     //为切换页码时调用
        this.loadLogList();
    }

  }


  changeSelect = (name, value) => {
    this.setState({
      [name]: value
    })
  }

//   huoyuanLink = (item) => {
//     var url = "https://detail.1688.com/offer/" + item.ProductId + ".html";

//     if(item.SourcePlatform == 'TaoteZhuKe')
//     {
//         var url ='https://market.m.taobao.com/app/nozomi/app-h5-detail/main/index.html?id='+item.ProductId
//     }
//     window.open(url, "_blank");
// }

  
  //上传尺码表展示 ---------------- 开始------------------------------------
  changeCheckTitle(e, titleLength) {
      let value = e.target.value;
      this.setState({
          [titleLength]: value.length
      })
  }
  onChangeForm(value, name) {
      this.setState({
          [name]: value
      })
  }
  addCustomSku() {//添加自定义规格
      let upSizeCustomSku = trim(this.state.upSizeCustomSku);
      let upSizeSpecOptions = this.state.upSizeSpecOptions;

      let isHas=false;
      upSizeSpecOptions.forEach((item,index)=>{
          if(item.text==upSizeCustomSku){
              isHas=true;
          }
      })
      if(isHas){
          messageShow("请输入规格名称已存在", 'info');
          return;
      }
      if (upSizeCustomSku) {
          let obj = {};
          obj.text = this.state.upSizeCustomSku;
          obj.value = this.state.upSizeCustomSku;
          obj.require = false;
          obj.checked = false;
          upSizeSpecOptions.push(obj);
          this.setState({
              upSizeSpecOptions,
              isShowCustomSku: false,
              upSizeCustomSku: ""
          },()=>{
              this.changeAddSkuCheck(null,obj.text);
          })
      } else {
          messageShow("请输入规格名称", 'info');
      }
  }

  changeAddSkuCheck(e,text){
      let upSizeSpecOptions=this.state.upSizeSpecOptions;
      let upSizeConfigTable=this.state.upSizeConfigTable;
      for(let i=0;i<upSizeSpecOptions.length;i++){
          if(upSizeSpecOptions[i].text==text){
              let checked=upSizeSpecOptions[i].checked;
              upSizeSpecOptions[i].checked=!checked;
              if(!upSizeSpecOptions[i].checked){
                  for(let j=0;j<upSizeConfigTable.length;j++){
                      for(let k in upSizeConfigTable[j]){
                          if(upSizeSpecOptions[i].text==k){
                              delete upSizeConfigTable[j][k];
                          }
                      }
                  }
              }else{
                  for(let j=0;j<upSizeConfigTable.length;j++){
                      let isHas=false;
                      for(let k in upSizeConfigTable[j]){
                          if(upSizeSpecOptions[i].text==k){
                              isHas=true;
                          }
                      }
                      if(!isHas){
                          upSizeConfigTable[j][text]=""
                      }
                  }
              }
          }
      }
      this.setState({
          upSizeSpecOptions,
          upSizeConfigTable
      })
  }

  changeupSizeConfigTable(e,key,index){
      let upSizeConfigTable=this.state.upSizeConfigTable;
      for(let i=0;i<upSizeConfigTable.length;i++){
          if(i==index){
              upSizeConfigTable[i][key]=e
          }
      }
      this.setState({upSizeConfigTable});
      console.log(upSizeConfigTable)
  }
  addUpSizeConfigTable(){
      let upSizeConfigTable=this.state.upSizeConfigTable;
      let upSizeSpecOptions=this.state.upSizeSpecOptions;
      let obj={};
      obj["size"] = ""
      for(let i=0;i<upSizeSpecOptions.length;i++){
          if(upSizeSpecOptions[i].checked){
              obj[upSizeSpecOptions[i].text]=""
          }
      }
      upSizeConfigTable.push(obj);
      this.setState({
          upSizeConfigTable
      },()=>{
          var div = document.getElementById('addSkuDailogWrap_down');	                 
      div.scrollTop = div.scrollHeight;
      })
  }
  deleteCustomSku(index){
      let upSizeConfigTable=this.state.upSizeConfigTable;
      let newUpSizeConfigTable=upSizeConfigTable.filter((item,i)=>i!=index)
      this.setState({upSizeConfigTable:newUpSizeConfigTable})
  }
  changeCustomSkuPosition(index,isTrue){

      let upSizeConfigTable=this.state.upSizeConfigTable;
      if(isTrue && index==0){
          return;
      }else if(!isTrue && index==(upSizeConfigTable.length-1)){
          return;
      }
      
      let tarIndex=0;
      tarIndex=isTrue?index-1:index+1;
      let currentItem=upSizeConfigTable[index];
      let targetItem=upSizeConfigTable[tarIndex];
      upSizeConfigTable[index]=targetItem;
      upSizeConfigTable[tarIndex]=currentItem;
      this.setState({
          upSizeConfigTable
      })

  }
  showAddUpSizeCustomSku(item)
  {
      const data = {
          ShopId : item.ListingTask.TargetShopId,
          ListingTaskCode : item.ListingTask.ListingTaskCode
      }
      var that = this;
      that.setState({
          upSizeSpecOptions:[],
          upSizeConfigTable:[],
          selectedTask:null
      })

      loadSizeComponentTamplate(data).then(res =>{
          that.setState({ isLoading :false})
          if(res.Success == true)
          {
              if(res.Data.ComponentFrontData.SpecOptions && res.Data.ComponentFrontData.SpecOptions.length > 0)
              {
                  res.Data.ComponentFrontData.SpecOptions.forEach(s => s.checked = s.require == true);
                  that.state.upSizeSpecOptions.push(...res.Data.ComponentFrontData.SpecOptions);
              }
              if(res.Data.ComponentFrontData.ConfigTable)
              {
                  for(var size in res.Data.ComponentFrontData.ConfigTable)
                  {
                      var configTable = res.Data.ComponentFrontData.ConfigTable;
                      var sizeInfo = { 'size':size}
                      for(var spec in configTable[size])
                      {
                          sizeInfo[spec] = "";
                      }
                      that.state.upSizeConfigTable.push(sizeInfo);
                  }
              }
              that.setState({
                  isShowUpSizeCustomSkuDailog:true,
                  upSizeSpecOptions:that.state.upSizeSpecOptions,
                  upSizeConfigTable:that.state.upSizeConfigTable,
                  upTemplateSubType:res.Data.TemplateSubType,
                  selectedTask:item
              })
          }else{
              // app.MessageShow("error","加载尺寸模板信息失败",3000);
              that.setState({
                  isShowUpSizeCustomSkuDailog:true,
                  upSizeSpecOptions:[],
                  upSizeConfigTable:[],
                  selectedTask:item
              })
          }
          
      });
      
  }

  saveUpSizeCustomSku(task)
  {
      if(!this.state.upSizeTitle || this.state.upSizeTitle.length == 0)
      {
          messageShow("请输入标题",'error')
          return;
      }
      if(!this.state.upSizeDesc || this.state.upSizeDesc.length == 0)
      {
          messageShow("请输入标题注释",'error')
          return;
      }

      let configTable = { };
      this.state.upSizeConfigTable.forEach(config => { 
              var item = { }
              for(let info in config){
                  if(info != 'size') item[info] = config[info]
              }
              configTable[config['size']] = item;
      })
      var componentFrontData = {
          Title:this.state.upSizeTitle,
          Desc:this.state.upSizeDesc,
          SpecOptions:this.state.upSizeSpecOptions.map(s => s.value),
          ConfigTable:configTable
      }
      
      const data = {
          ListingTaskCode:this.state.selectedTask.ListingTask.ListingTaskCode,
          ShopId:this.state.selectedTask.ListingTask.TargetShopId,
          TemplateSubType:this.state.upTemplateSubType,
          ComponentFrontData:componentFrontData
      };
      var that = this;
      that.setState({ isLoading : true,loadingTitle:"上传尺码信息中..."});
      saveSizeComponentTamplate(data).then(res =>{
          that.setState({ isLoading : false,loadingTitle:""});
          if(res.Success == true)
          {
              that.setState({ isShowUpSizeCustomSkuDailog:false })
              messageShow('上传成功！请稍后几分钟查看结果','success');
          }else
          {
              messageShow(res.Message,'error');
          }
      });      
  }

  saveProductEdit = (titles, catePropsList, salesPropList, skuList, isPh, catePath, ImageInfo,platformRecommendId) => {
    var listingTask = this.state.listingProductEditByProduct;

    var data = {
        Title: titles,
        PlatformRecommendId:platformRecommendId,
        SupplierProductCode: listingTask.supplierProductCode,
        SupplierProductId: listingTask.supplierProductId,
        CatePathList:catePath,
        SourcePlatform: listingTask.sourcePlatform,
        CateProps: catePropsList,
        SalesProps: salesPropList,
        Skus: skuList,
        ShopId: listingTask.targetShopId,
        PlatformType: listingTask.targetPlatformType,
        ListingTaskCode: listingTask.taskCode,
        IsPuHuo: isPh,
        ImageInfo: ImageInfo,
        Source: "铺货日志",
    }
    console.log(JSON.stringify(data))

    var that = this
    this.setState({ isLoading:true})
    requests({
        url: "/Product/SaveOrSavePuHuoSupplier",
        data: data,
        success: function (res) {
            that.setState({ isLoading: false });
            if (res.RequestError == true) {//请求失效了。isLoading关闭看需求写
                that.setState({ isLoading: false });
                return;
            }

            if (res.Success) {
                if(isPh){
                    that.queryButton(true);
                }
            } else {
                messageShow("保存错误：" + res.Message,'error');
            }
        },
    });



    //if(!isChangeCate)//如果是更换类目则不关闭弹窗
        this.setState({ isShowListingProductEditDailog: false });
}

    closeListingProductEdit = () => {
        this.setState({ isShowListingProductEditDailog: false })
    }
    GetListingProductByCateId = async (listingProduct) => {
        var listingTask = this.state.listingProductEditByProduct;
        const data = { }
        data.TargetShopIds = listingTask.targetShopId
        data.TargetPlatformType = listingTask.targetPlatformType
        data.TaskCode = listingTask.taskCode
        data.ListingProduct = listingProduct
        this.setState({isLoading : true})
        const res = await GetListingProductByCateIdRequest(data);
        this.setState({isLoading : false})
        if(res.Success && res.Data && res.Data.ProductEditDataList && res.Data.ProductEditDataList.length > 0){
          return res.Data.ProductEditDataList[0];
        }
        return null
    }


  render() {

    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeNav} defaultActive={"/distributionLog"} />
          </div>
          <div className="wrap-right">
          <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>

            <div className='searchWrap mywrap'>
              <Select onChange={this.changeSelect.bind(this, "selectDay")} value={this.state.selectDay} clearable={true} style={{ width: "200px", marginRight: "10px" }}	>
                {
                  this.state.daySelect.map((el) => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
              <Input value={this.state.productTitle} onChange={this.onChangeInput.bind(this, "productTitle")} style={{ width: "200px", marginRight: "15px" }} placeholder='请输入商品名称' />
              <Button type="primary" onClick={() => this.queryButton(true)}>查询</Button>
            </div>

            <div className='mywrap'>
              <Tabs value="0" onTabClick={this.changeTabs.bind(this)}>
                <Tabs.Pane label="全部" name="0"></Tabs.Pane>
                <Tabs.Pane label="铺货中" name="1"></Tabs.Pane>
                <Tabs.Pane label="铺货成功" name="2"></Tabs.Pane>
                <Tabs.Pane label="铺货失败" name="3"></Tabs.Pane>
              </Tabs>
              <table className='table-style01'>
               <thead>
                  <tr>
                    <th style={{ width: "320px" }}>货源商品</th>
                    <th style={{ width: "100px" }}>价格/库存</th>
                    <th style={{ width: "120px" }}>铺货平台/店铺</th>
                    <th style={{ width: "150px",textAlign:'center',display:this.state.selectplatformType == 'TouTiao' ? 'revert':'none'}}>主图视频</th>
                    <th style={{ width: "100px" }}>铺货状态</th>
                    <th style={{ width: "300px" }}>说明</th>
                    <th style={{ width: "100px" }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                   {
                    this.state.logList.map((item, index) =>
                    <tr>
                          <td>
                              <div className='table-product'>
                                  <div>
                                      <img style={{width:"50px",height:"50px"}} src={item.SupplierProduct.PicURI} alt="" />
                                  </div>
                                  <ul>
                                      <li title="商品标题">{item.SupplierProduct.Subject}</li>
                                      <li><span className="mainColor">铺货时间：</span>{item.ListingTask.CreateTime}
                                      {
                                          item.ListingTask.SourcePlatform == "TaoteZhuKe"?
                                          <Tag type="warning" size="mini" style={{"borderRadius":"12px"}}>淘特货源</Tag>:null
                                      }
                                      {
                                          item.ListingTask.SupplierProductTag =="pifatuan"?
                                          <Tag type="warning" size="mini" style={{"borderRadius":"12px"}}>1688精选</Tag>:null
                                      }
                                    </li>
                                      
                                  </ul>
                              </div>
                          </td>
                          <td>
                              <div className="mainColor">¥{item.SupplierProduct.ReferencePrice}<i style={{ padding: "0 5px" }}>/</i><span style={{ color: "#999" }}>{item.SupplierProduct.SupplyStock}</span></div>
                          </td>
                          <td>
                              <div className="newPlatformIconWrap">
                                 <img style={{width:"20px",height:"20px"}} src={"https://www.dgjapp.com/public/images/zhipoIcon/platform-icon-"+item.ListingTask.TargetPlatformType+".png"} />
                                  <span style={{ marginLeft: "5px" }}>{this.state.selectShopName}</span>
                              </div>
                          </td>
                          {
                            this.state.selectplatformType == 'TouTiao'?
                                <td>
                                    {
                                        item.UploadMaterialHistory ?
                                        <div>
                                            <div className='hover'  onClick={()=>{ window.open(item.UploadMaterialHistory.OriginalUrl)}} style={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:'10px',marginBottom:'10px'}}>
                                                <span className='iconfont icon-bofang'></span>
                                            </div>
                                            <div  style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                {
                                                    item.UploadMaterialHistory.MaterialStatus == 'None' ? <span>等待上传主图视频素材</span>:null
                                                }
                                                {
                                                    item.UploadMaterialHistory.MaterialStatus == 'Auditing' ? <span>素材审核中</span>:null
                                                }
                                                {
                                                    item.UploadMaterialHistory.MaterialStatus == 'Reject' ? <span className='ellipsis' title={item.UploadMaterialHistory.RejectMssage} style={{width:'200px',color:'rgb(255, 81, 28)'}}>{item.UploadMaterialHistory.RejectMssage}</span>:null
                                                }
                                                {
                                                    item.UploadMaterialHistory.MaterialStatus == 'Passed' ? <span>审核通过</span>:null
                                                }
                                            </div>
                                        </div>:null
                                    }
                                    
                                </td>:null
                          }
                          {
                            // systemConfig.isZk5() || systemConfig.isZk1()?
                              <td>
                                <span className="table-td-zt">
                                    {item.ListingTask.Status == "Created" ? <div><i className="dot-ZT" style={{ backgroundColor: "#f7941f" }}></i><span>已创建铺货任务</span></div> : null}
                                    {item.ListingTask.Status == "Doing" ? <div><i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i><span>正在铺货中...</span></div> : null}
                                    {item.ListingTask.Status == "Success"  || item.ListingTask.Status == "SuccessWaitCallBack" ? <div><i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i><span>铺货成功</span></div> : null}
                                    {item.ListingTask.Status == "Error" ? <div><i className="dot-ZT" style={{ backgroundColor: "#ff511c" }}></i><span>铺货失败</span></div> : null}
                                    {
                                      item.ListingTask.Status == "WaitRetry" || item.ListingTask.Status == "WaitRetryDoing"  || item.ListingTask.Status == "WaitRetryLocked" ? 
                                          this.state.listingProductSubStauts[item.ListingTask.SubStatus] ? 
                                          <div>
                                            <i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i>
                                            <span>{ this.state.listingProductSubStauts[item.ListingTask.SubStatus].text}</span>
                                            {/* <span>【测试展示：当前状态{item.ListingTask.Status }】</span> */}
                                          </div> : 
                                          <div><i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i><span>正在铺货中...</span></div>
                                      :null
                                    }
                                    
                                </span>
                            </td>
                            // :
                            // <td>
                            //   <span className="table-td-zt">
                            //       {item.ListingTask.Status == "Created" ? <div><i className="dot-ZT" style={{ backgroundColor: "#f7941f" }}></i><span>已创建铺货任务</span></div> : null}
                            //       {item.ListingTask.Status == "Doing" ? <div><i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i><span>正在铺货中...</span></div> : null}
                            //       {item.ListingTask.Status == "Success" ? <div><i className="dot-ZT" style={{ backgroundColor: "#027cff" }}></i><span>铺货成功</span></div> : null}
                            //       {item.ListingTask.Status == "Error" ? <div><i className="dot-ZT" style={{ backgroundColor: "#ff511c" }}></i><span>铺货失败</span></div> : null}
                            //   </span>
                          	// </td>
                          }
                          {
                            // systemConfig.isZk5() || systemConfig.isZk1()?
                            <td>
                              {
                                  item.ListingTask.Status == "Success" || item.ListingTask.Status == 'SuccessWaitCallBack' || item.ListingTask.ErrorMessage == null || item.ListingTask.ErrorMessage == "" ? null
                                      :
                                    //   <div className="ellipsis" style={{width:'200px'}} title={item.ListingTask.ErrorMessage}>
                                    //     <span className="table-td-zt" style={{ color: "#ff511c" }}>
                                    //         {item.ListingTask.ErrorMessage}
                                    //     </span>
                                    //   </div>
                                      <div className='popoverCommon ' style={{'display':'inline-block',marginLeft:'10px'}}>
                                        
                                        <span className="table-td-zt dangerColor hover" style={{'whiteSpace':'nowrap','overflow':'hidden','textOverflow':'ellipsis','width':'200px','display':'inline-block',color: "#ff511c" }}>
                                             {item.ListingTask.ErrorMessage}
                                         </span>
                                        <div className='popoverCommon-warn' style={{width:'max-content',maxWidth:'300px',lineHeight:'25px',color:'#333'}}>
                                        {
                                            item.ListingTask.ErrorCode == "tbStopPhError" ?
                                            
                                                <span>
                                                    由于淘宝业务调整，暂时不能铺货到淘宝店铺。其他关联、采购等功能不受影响。 如有疑问，请<a className='hover defColor' onClick={() => { window.open("https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?touid=%E4%B8%AD%E6%81%92%E7%94%B5%E5%95%86&from=isv#/", "_blank"); }}>联系客服</a> 处理
                                                </span>                                           
                                            :  <span> {item.ListingTask.ErrorMessage}</span>
                                        }
                                           
                                        </div>
                                    </div>
                              }
                              {
                                  item.ListingTask.Status == 'SuccessWaitCallBack' ? 
                                    <div style={{width:'200px'}} title={item.ListingTask.ErrorMessage}>
                                        <span style={{ display: "block", marginBottom: "3px" }}>
                                            商品代销关系建立失败，请到【<a className='hover defColor' onClick={()=>{ this.urlLink('/shopProduct') }}>店铺商品</a> 】找到此商品，手动关联货源
                                        </span>
                                    </div>
                                    :null
                              }
                              {
                                  item.ListingTask.Status == "Success" && item.CateNameList.length > 0 ?
                                    <div style={{width:'200px'}} title={item.ListingTask.ErrorMessage}>
                                          <span style={{ color: "#77bf04", display: "block", marginBottom: "3px" }}>
                                              以下类目属性未匹配到1688信息，请核对后去店铺后台修改：
                                          </span>
                                          {
                                              item.CateNameList.map((cateItem) =>
                                                  <span style={{ fontSize: 12, padding: "1px 3px", color: "#77bf04", backgroundColor: "#77bf04", color: "#fff", marginRight: "5px", marginBottom: "5px" }}>{cateItem.CateName}</span>
                                              )
                                          }
                                      </div> : null
                              }
                                    
                              
                            </td>
                            // :
                          	// <td>
                            //   {
                            //       item.ListingTask.Status == "Success" || item.ListingTask.ErrorMessage == null || item.ListingTask.ErrorMessage == "" ? null
                            //           :
                            //           <span className="table-td-zt" style={{ color: "#ff511c" }}>
                            //               {item.ListingTask.ErrorMessage}
                            //           </span>
                            //   }
                            //   {
                            //       item.ListingTask.Status == "Success" && item.CateNameList.length > 0 ?
                            //           <div>
                            //               <span style={{ color: "#77bf04", display: "block", marginBottom: "3px" }}>
                            //                   以下类目属性未匹配到1688信息，请核对后去店铺后台修改：
                            //               </span>
                            //               {
                            //                   item.CateNameList.map((cateItem) =>
                            //                       <span style={{ fontSize: 12, padding: "1px 3px", color: "#77bf04", backgroundColor: "#77bf04", color: "#fff", marginRight: "5px", marginBottom: "5px" }}>{cateItem.CateName}</span>
                            //                   )
                            //               }
                            //           </div> : null
                            //   }
                          	// </td>
                          }
                          <td>
                            {
                                item.ListingTask.ErrorMessage && item.ListingTask.ErrorMessage.includes('上传完整尺码表信息')  ?
                                <span className="defColor hover" style={{ marginRight: "10px" }} onClick={() => this.showAddUpSizeCustomSku(item)}>上传尺码表</span>
                                :null
                            }
                          <span className="defColor hover" style={{ marginRight: "10px" }} onClick={() => huoyuanLink(item.SupplierProduct)}>货源</span>
                              {/* <Button type="info" size="small"  onClick={() => this.cancelPreview()}>重新铺货</Button> */}
                            {
                                item.ListingTask.Status == "Error" 
                                && item.ListingTask.TargetPlatformType != "Taobao"  ?
                                    <span className="defColor hover" onClick={() => this.showListingProductEditDailog(item)}>去修改</span> : null
                            }
                          </td>
                      </tr>
                    )
                   }
                   {
                    !this.state.logList.length?<tr><td colSpan="20" className='noTableData'><div className='noTableData-wrap'><i className='iconfont icon-wushuju'></i>暂无数据！</div></td></tr>:""
                   }
                  

                </tbody>
              </table>
             
             <div className='paginationwrap'>
                <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.total} pageSize={this.state.pageSize} currentPage={this.state.current} pageSizes={[10,30,50]} />
             </div>
            </div>
          </div>
        </main>
        <ShowModal
            titleName={"添加尺码信息"}
            width={"800px"}
            showModal={this.state.isShowUpSizeCustomSkuDailog}
            sureDailog={() => this.saveUpSizeCustomSku()}
            sureBtnName={"确定"}
            cancelDailog={() => this.cancelModul("isShowUpSizeCustomSkuDailog")}
        >
          <div className='addSkuDailogWrap'>
              <div className="addSkuDailogWrap-up">
                  <div className="addSkuDailogWrap-titeInput">
                      <i style={{color:"#ff511c"}}>*</i>
                      <span className='addSkuDailogWrap-titeName'>标题</span>
                      <Input className="addSkuDailogWrap-up-input" placeholder={"请填写尺码标题"} type="text" value={this.state.upSizeTitle} onInput={(e) => this.changeCheckTitle(e, "upSizeTitleLenght")} onChange={(e) => this.onChangeForm(e, "upSizeTitle")} maxLength={10} />
                      <div className="titeInputWrap-rightWrap"><span>{this.state.upSizeTitleLenght}</span><i>/</i><span>10</span></div>
                  </div>
                  <div className="addSkuDailogWrap-titeInput">
                      <span className='addSkuDailogWrap-titeName' style={{ marginLeft: "15px" }}><i style={{color:"#ff511c"}}>*</i>标题注释</span>
                      <Input className="addSkuDailogWrap-up-input" placeholder={"请填写标题注释"} type="text" value={this.state.upSizeDesc} onInput={(e) => this.changeCheckTitle(e, "upSizeDescLength")} onChange={(e) => this.onChangeForm(e, "upSizeDesc")} maxLength={20} />
                      <div className="titeInputWrap-rightWrap"><span>{this.state.upSizeDescLength}</span><i>/</i><span>20</span></div>
                  </div>
              </div>
              <div className='addSkuDailogWrap-mid'>
                  <span className='addSkuDailogWrap-mid-title'>选择规格</span>
                  <ul className='addSkuDailogWrap-mid-main'>
                      {
                          this.state.upSizeSpecOptions.map((item,index) =>
                              item.require ?
                                  <li className='addSkuDailogWrap-mid-main-item stopOperate'>
                                      <label><i>*</i><input type="checkbox" checked={true} /><span className='sku-title'>{item.text}</span></label>
                                  </li> :
                                  <li className='addSkuDailogWrap-mid-main-item'>
                                      <label><input type="checkbox" checked={item.checked} onChange={(e)=>this.changeAddSkuCheck(e,item.text)} /><span className='sku-title'>{item.text}</span></label>
                                  </li>

                          )
                      }

                      <li className='addSkuDailogWrap-mid-main-addWrap'>
                          {
                              this.state.isShowCustomSku ?
                                  <div className='addSkuDailogWrap-mid-inputWrap'>
                                      <Input className="addSkuDailogWrap-up-input" placeholder={"请输入规格名称 "} type="text" value={this.state.upSizeCustomSku} onChange={(e) => this.onChangeForm(e, "upSizeCustomSku")} maxLength={10} />
                                      <div className='addSkuDailogWrap-up-btns'>
                                          <span className='norDefBtn' onClick={() => this.addCustomSku()}>确定</span>
                                          <span className='comBtn' onClick={() => this.setState({ isShowCustomSku: false, upSizeCustomSku: "" })}>关闭</span>
                                      </div>
                                  </div> : ""
                          }
                          <span className='addSkuDailogWrap-mid-main-add' onClick={() => this.setState({ isShowCustomSku: true })}>
                              <i className='iconfont icon-jia-copy1'></i><span>自定义规格</span>
                          </span>
                      </li>
                  </ul>
              </div>
              <div className='addSkuDailogWrap-down' id="addSkuDailogWrap_down">
                  <table class="table-style01 orderList">
                      <thead>
                          <tr>
                              <th style={{ minWidth: "100px;" }}><i>*</i>尺码</th>
                              {
                                  this.state.upSizeSpecOptions.map((item, index) =>
                                      item.checked ?
                                          <th style={{ minWidth: "100px;" }}><i style={item.require ? { display: "inline-block" } : { display: "none" }}>*</i>{item.text}</th>
                                          : null
                                  )
                              }
                              <th style={{ minWidth: "150px" }}>操作</th>
                          </tr>
                      </thead>
                      <tbody id="upSizeConfigTableTbody">
                          {
                              this.state.upSizeConfigTable.map((item, index) =>                                 
                                  <tr>
                                      {/* {
                                          Object.keys(item).map((chItem,chIndex)=>
                                              <td>
                                                  <Input className="addSkuDailogWrap-up-input" placeholder={!item[chItem]?"请输入":""} type="text" value={item[chItem]} onChange={(e)=>this.changeupSizeConfigTable(e,chItem,index)} />                                                     
                                              </td>
                                          )
                                          
                                      } */}
                                      {
                                          Object.keys(item).sort((a,b)=> {
                                              return this.state.upSizeSpecOptions.findIndex(x => x.text == a) - this.state.upSizeSpecOptions.findIndex(x => x.text == b)
                                          }).map((chItem,chIndex)=>
                                          <td>
                                              <Input className="addSkuDailogWrap-up-input" style={{width:"100%"}} placeholder={!item[chItem]?"请输入":""} type="text" value={item[chItem]} onChange={(e)=>this.changeupSizeConfigTable(e,chItem,index)} />                                                     
                                          </td>
                                          )
                                      }
                                      <td>
                                          <span className="defColor hover operteBtn" style={{ marginRight: "10px" }} onClick={()=>this.changeCustomSkuPosition(index,true)}>上移</span>
                                          <span className="defColor hover operteBtn" style={{ marginRight: "10px" }} onClick={()=>this.changeCustomSkuPosition(index,false)}>下移</span>
                                          <span className="dangerColor hover" onClick={()=>this.deleteCustomSku(index)} style={{ marginRight: "10px" }}>删除</span>
                                      </td>
                                  </tr>
                              )
                          }
                      </tbody>
                  </table>
                  <div className='addSkuDailogWrap-down-btns'>
                      <Button type='primary' onClick={()=>this.addUpSizeConfigTable()}>添加行</Button>
                      {/* <span className='norDefBtn' onClick={()=>this.addUpSizeConfigTable()}>添加行</span> */}
                  </div>
              </div>

          </div>
        </ShowModal>    
        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />

        <NewUserGuide></NewUserGuide>
        {
            this.state.isShowListingProductEditDailog == true ?
                <ListingProductEdit cancelDailog={this.closeListingProductEdit} showModal={this.state.isShowListingProductEditDailog} products={this.state.listingProductEditByProduct} saveProductEdit={this.saveProductEdit} saveAndPuhuoProductEdit={this.saveAndPuhuoProductEdit} changeCate={this.GetListingProductByCateId} /> : null
        }

      </div>

    )
  }
}

export default distributionLog;


// WEBPACK FOOTER //
// ./src/pages/distributionLog/distributionLog.jsx